import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SiteSettingsContext = createContext(null);

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios.get(`${API}/settings`)
      .then(res => setSettings(res.data))
      .catch(() => setSettings({
        contact_email: 'tropiluxejamaica@yahoo.com',
        contact_phone: '+1 (876) 555-0123',
        address: 'Montego Bay & Negril, Jamaica',
        social_media: { instagram: '@tropiluxe', facebook: 'TropiluxeJamaica' },
        locations: []
      }));
  }, []);

  return (
    <SiteSettingsContext.Provider value={settings}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext);
